<section class="home-banner" [class.home-banner--juridica]="isJuridica" aria-label="Bienvenida">
  <div class="home-banner__overlay">
    <div class="home-banner__overlay-inner">
      <h1 class="home-banner__name">{{ displayName }}</h1>
      <p class="home-banner__welcome">{{ copy.welcome }}</p>
    </div>
  </div>

  <div class="home-banner__media" aria-hidden="true">
    <picture>
      <source media="(max-width: 767.98px)" [attr.srcset]="portraitSrcMobile" />
      <img class="home-banner__portrait" [src]="portraitSrc" width="1774" height="887"
        sizes="100vw" decoding="async"
        [alt]="isJuridica ? 'Persona jurídica' : 'Persona natural'" />
    </picture>
  </div>
</section>